// extracted by mini-css-extract-plugin
export default {"body":"teacherinvest_body__FqFgn","content":"teacherinvest_content__J1tBx","potential":"teacherinvest_potential__N+eMr","photo":"teacherinvest_photo__C5ksF"};